import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { Step } from '../../../shared/interfaces/step';
import { YoutubeVideoPlayerComponent } from './youtube-video-player/youtube-video-player.component';
import { HtmlVideoPlayerComponent } from './html-video-player/html-video-player.component';
import { Sale } from '../../../shared/interfaces/sale';

@Component({
    selector: 'app-step-display-video',
    standalone: true,
    imports: [CommonModule, YoutubeVideoPlayerComponent, HtmlVideoPlayerComponent],
    templateUrl: './step-display-video.component.html',
    styleUrl: './step-display-video.component.scss',
})
export class StepDisplayVideoComponent {
    @Input({ required: true }) public formGroup!: FormGroup;

    @Input({ required: true }) public sale!: Sale;

    @Input({ required: true }) public step!: Step;

    public get getVideoPath(): string | undefined {
        return this.step?.settings?.['videoPath'] as string | undefined;
    }

    public get getVideoType(): string | undefined {
        return this.step?.settings?.['type'] as string | undefined;
    }

    public onWatched(): void {
        this.formGroup?.get('_watched')?.setValue(true);
    }
}
